"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ethers_1 = require("ethers");
var constants_1 = require("../constants");
var ArcNumber = /** @class */ (function () {
    function ArcNumber() {
    }
    ArcNumber.new = function (amount, decimals) {
        if (decimals === void 0) { decimals = 18; }
        return ethers_1.BigNumber.from(10).pow(decimals).mul(amount);
    };
    ArcNumber.bigMul = function (value1, value2) {
        return value1.mul(value2).div(constants_1.BASE);
    };
    ArcNumber.bigDiv = function (value1, value2) {
        return value1.mul(constants_1.BASE).div(value2);
    };
    return ArcNumber;
}());
exports.default = ArcNumber;
//# sourceMappingURL=ArcNumber.js.map